import _ from "lodash";
import { graphql } from "lib/apolloClient";
import { getAITutorConversationQuery } from "./AITutorChatQueries";
import { getAssessmentRequiredFieldValues } from "./Utils";
import { mergeAndFilterAITutorMessages } from "Utils/AIUtils";
import { getIsAITutorModalitiesEnabled } from "Utils/ACLStoreUtils";

export const getAITutorConversationsEnhancer = graphql(
  getAITutorConversationQuery,
  {
    name: "getAIConversations",
    skip: ({
      aiConversationId,
      isLibraryAssessmentLoading = true,
      isLibrary = false,
    }) => {
      return (
        _.isEmpty(aiConversationId) || (isLibrary && isLibraryAssessmentLoading)
      );
    },
    options: ({
      aiConversationId,
      portalType,
      fetchPolicy = "cache-and-network",
    }) => ({
      fetchPolicy,
      variables: { id: aiConversationId, portalType },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getAIConversations,
      ownProps: {
        isData,
        isLoading,
        assessmentDetails,
        isStaff,
        leId,
        isInitialState = false,
      },
    }) {
      const queryData = _.get(getAIConversations, "node", {});

      const networkStatus = _.get(getAIConversations, "networkStatus");

      const messageEdges = [
        ..._.get(queryData, "messages.edges", []),
      ].reverse();

      const messages = mergeAndFilterAITutorMessages(messageEdges);

      const conversationMetadata = _.get(queryData, "metadata");
      const conversationAttachments = _.get(queryData, "attachments", []);
      const analysisToolEvaluation = _.get(
        queryData,
        "analysisToolEvaluation",
        []
      );

      const metadataRequiredFieldValues = _.get(
        conversationMetadata,
        "assessmentRequiredFieldValues",
        []
      );

      const assessmentRequiredFieldValues = getAssessmentRequiredFieldValues({
        assessmentDetails,
        fields: [
          "title",
          "aiRole",
          "aiRules",
          "openingMessage",
          "description",
          "tutorLanguage",
        ],
      });

      if (getIsAITutorModalitiesEnabled()) {
        const aiConversations = _.get(
          assessmentDetails,
          "aiConversation.edges"
        );

        const taskCreationConversation = _.find(aiConversations, ({ node }) => {
          return node?.entitySubType === "TASK_CREATION";
        });

        const taskCreationConversationMetadata = _.get(
          taskCreationConversation,
          "node.metadata"
        );

        const taskCreationConversationRequiredFieldValues = _.pick(
          taskCreationConversationMetadata,
          ["tutorLearningGoals", "instructionsForTTSModel"]
        );

        if (!_.isEmpty(taskCreationConversationRequiredFieldValues)) {
          _.forEach(
            taskCreationConversationRequiredFieldValues,
            (value, key) => {
              const keyExists = _.some(assessmentRequiredFieldValues, item =>
                _.has(item, key)
              );

              if (!keyExists) {
                assessmentRequiredFieldValues.push({ [key]: value });
              }
            }
          );
        }
      }

      return {
        onPusherEventTriggered: params => {
          if (isStaff && params.assessmentId == leId) {
            getAIConversations.refetch();
          }
        },
        messages,
        isFetchingMoreData: networkStatus == 3,
        conversations: queryData,
        isInitialState: isInitialState || _.isEmpty(messages),
        conversationMetadata,
        conversationAttachments,
        metadataRequiredFieldValues,
        assessmentRequiredFieldValues,
        analysisToolEvaluation,
        isData: !_.isEmpty(queryData) && isData,
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  }
);
